export const profileTab = {
  _id: 'profile-1J8F7K',
  name: 'Profile',
  slug: 'profile-tab',
  icon: 'user',
} as const;
